<div class="overlay" [class.visible]="isVisible" (click)="openSidebar(false)"></div>
<div class="sidebar" [class.visible]="isVisible" *ngIf="isVisible">
  <mat-icon (click)="openSidebar(false)" class="arrow">arrow_back</mat-icon>
  <div class="header">
    <img src="assets/images/logos/mobile_autoverse_logo.svg"  class="logo" />
    <span>AUTOVERSE</span>
    <h2>Tell us your car number 🚗</h2>
    <p class="subtitle">So we can show you the right parts, fast!</p>
  </div>

 <div class="input-box">
  <label for="carNumber">Enter your car number</label>
  <p class="clutch-sub" *ngIf="fromClutchFlow">
    We’ll find your clutch instantly
  </p>
  <input
   id="carNumber"
   type="text"
   placeholder="e.g. KA01MF1234"
   [value]="carNumber"
   (input)="onCarNumberInput($event)"
    autocomplete="off"
    maxlength="13"
  />
  
  <!-- Error message -->
  <div class="error-msg" *ngIf="showError">
    Please enter your registration number
  </div>
  <div class="clutch-benefits" *ngIf="fromClutchFlow">
    <span>⚡ Dispatched in 15 mins</span>
    <span>🛡️ Warranty included</span>
  </div>
  <!-- <button class="find-btn" (click)="onFindMyCar()">Find My Car</button> -->
  <button class="find-btn" (click)="onFindMyCar()"> {{ fromClutchFlow ? 'Find My Clutch' : 'Find My Car' }}</button>
</div>


  <div class="upload-section">
    <p class="or-text">Don't want to type?</p>
    <input type="file" hidden #fileInput (change)="onImageSelected($event)">
    <button class="upload-btn" (click)="triggerFileInput(fileInput)">
      <span>📸 Upload Photo of Car Number</span>
    </button>
  </div>

  <div class="info-box">
    ✅ See only matching parts 
    ✅ No model confusion 
    ✅ Faster delivery
  </div>

  <div class="manual-option">
    <!-- <p (click)="redirectToManualSelection()">Or select your car manually</p> -->
    <small>*We don’t store your image. It’s only used to detect your car.*</small>
  </div>
  
   <div class="overlay" [class.visible]="notFound" (click)="notFoundClose()"></div>
  <div class="detection-container" *ngIf="notFound">
  <div class="header">
     <img class="icon" src="../../../../assets/images/home-page-reg-number/cercle.png">
    <div>
    <div class="title">We couldn't identify your car automatically</div>
    <p class="subtext">
      This can happen if the number plate is unclear, the format is unusual, or the vehicle isn't in our database yet.
    </p>
    </div>
    <i (click)="notFoundClose()">close</i>
  </div>

  <div class="reasons-box">
    <h4><p>🟢</p> Common reasons:</h4>
    <ul>
      <li><img src="../../../../assets/images/order-details/div1.png">Photo not clear or has glare</li>
      <li><img src="../../../../assets/images/order-details/div1.png">Temporary or fancy font plates</li>
      <li><img src="../../../../assets/images/order-details/div1.png">Older registration formats</li>
    </ul>
  </div>

  <div class="actions">
    <button mat-button class="retry-btn" (click)="notFoundClose()">🔄 Try Again</button>
    <button mat-raised-button color="primary" class="manual-btn" (click)="redirectToManualSelection()">👉 Select Car Manually</button>
  </div>

  <div class="manual-note">
    💡 
    <div>
    <span>Manual selection</span><br />
    <p style="color: #5F7893;margin: 0;">
    lets you choose Make → Model → Variant → Year → Fuel so we can show you only the right parts for your vehicle.
    </p>
  </div>
  </div>
</div>

</div>
<div class="overlay1" [class.visible]="isOpenFull" (click)="closeDetails(false)"></div>
<div class="sidebar1" [class.visible]="isOpenFull" *ngIf="isOpenFull">
  <mat-icon (click)="closeDetails(false)" class="arrow">arrow_back</mat-icon>
<img src="../../../../assets/images/home-page-reg-number/found_regno.png">
<div class="car-details-container">
  <h3 class="reg-number" *ngIf="carNumber">Registration Number<br /><span>{{ carNumber }}</span></h3>

<div *ngFor="let detail of carDetails">
  <ng-container *ngIf="hasVehicleValue(detail.valueKey)">
    <div class="detail-row">
      <div class="label">{{ detail.label }}
      <div class="value">{{ getVehicleValue(detail.valueKey) }}</div>
      </div>
    <span class="check-icon"><i>done</i></span>
    
    </div>
  </ng-container>
</div>

  <button class="confirm-btn" (click)="confirmCar()">Yes, this is my car!</button>
  <button class="change-btn" (click)="closeDetails(false)">Change Car</button>
</div>
<p>Details not matching? you can update anytime.</p>
</div>
<div class="overlay" [class.visible]="openPartsEntry" (click)="closetext(false)"></div>
<div class="sidebar1" [class.visible]="openPartsEntry" *ngIf="openPartsEntry" style="padding: 0;background: linear-gradient(87deg, #F0F9FF, #E0F2FE, #F0FDFA);">
  

<div class="parts-container">
  <div class="need">
    <mat-icon (click)="closetext(false)" class="arrow">arrow_back</mat-icon>
    <div class="image">
    <img src="../../../../assets/images/home-page-reg-number/Frame.png">
    </div>
  <h2>What parts do you need?</h2>
  <p class="sub-heading">Just type or paste part names — like WhatsApp<i>sms</i></p>
  </div>
  <div class="ai-label"><div class="custom-dot"></div> AI-powered part recognition</div>

  <!-- Vehicle Info Card -->
   <div style="padding: 0 10px;">
  <div class="card vehicle-card">
    <div class="header">
    <div class="car">
    <img src="../../../../assets/images/home-page-reg-number/caricon.png">
    </div>
    <div class="vehicle">
      <p>
        Your Vehicle
      </p>
      <div><div class="custom-dot" style="    background-color: #10B981;margin-left: -23px;"></div> Connected & Ready</div>
    </div>
      <button class="change-btn" (click)="changeCar()"><i>star</i>Change Vehicle</button>
    </div>
    <div class="vehicle-info">
      <p><span class="icon">🚗</span> {{vehicleData.make}} {{vehicleData.model}} | {{vehicleData.variant}}</p>
      <p><span class="icon">⛽</span>{{vehicleData.fuel}}  | {{vehicleData.year}}  | {{carNumber}} </p>
    </div>
  </div>

  <!-- Quick Start Kit Card -->
  <div class="card kit-card" #myTargetDiv>
    <div class="header" style="justify-content: flex-start;gap: 6px;">
      <div class="notes">
    <i> notes</i>
    </div>
    <div class="quick">
     <p class="start">Quick Start Kits</p>
     <p>Pre-selected parts for common services</p>
  </div>
  </div>
    <!-- <select>
      <option disabled selected>🎯 Choose a pre-filled kit</option>
    </select> -->
     <!-- <mat-form-field appearance="outline" floatLabel="never" style="width: 100%;font-size: 12px;margin-bottom: -14px;">
        <mat-select #kitSelect
                    [(value)]="selectedKits"
                    (selectionChange)="onKitsChanged()"
                    multiple
                    [placeholder]="'🎯 Choose a pre-filled kit'"
                    class="select">
      
          <mat-select-trigger >
            🎯 Choose a pre-filled kit
          </mat-select-trigger>
      
          <mat-option *ngFor="let kit of kits" [value]="kit">
            {{ kit.name }}
          </mat-option>
      
            <div class="ok-button-container">
              <p (click)="closeSelectPanel(kitSelect)" style="margin-top: 0;">OK</p>
            </div>
      
        </mat-select>
      </mat-form-field> -->
<!-- Trigger button using mat-select -->
<mat-form-field appearance="outline" floatLabel="never" style="width: 100%; font-size: 12px;">
  <mat-select
    #kitSelect
    [value]="selectedKits.length ? 'Selected' : null"
    (click)="openKits()"
    disabled
    class="select"
    [placeholder]="'🎯 Choose a pre-filled kit'">
    <mat-select-trigger>
      🎯 Choose a pre-filled kit
    </mat-select-trigger>
  </mat-select>
</mat-form-field>

<!-- ✅ Custom Panel - shown on demand -->
<div *ngIf="openCustomPanel" class="kit-select-panel">
  <!-- Header -->
  <div class="kit-header">
    <div class="title">
      <strong>Select Part Kits</strong>
      <span>Choose one or more kits</span>
    </div>
    <button class="close-btn1" (click)="openCustomPanel = false">✕</button>
  </div>

  <!-- Search -->
  <div class="search-wrapper">
    <i>search</i>
    <input type="text" [(ngModel)]="searchText" placeholder="Search kits" />
    <i *ngIf="searchText" (click)="searchText = ''" style="position: absolute;right: 19px;font-size: 15px;cursor: pointer;">close</i>
  </div>

  <!-- Select All -->
  <div class="select-all" (click)="toggleSelectAll()">
    <input type="checkbox" [checked]="isAllSelected()" />
    <label>Select all</label>
    <span class="count">{{ kits.length }} items</span>
  </div>

  <!-- Kit List -->
  <div class="kit-list">
    <div
      class="kit-option"
      *ngFor="let kit of filteredKits()"
      [class.active]="selectedKits.includes(kit)"
      (click)="toggleKitSelection(kit)"
    >
      <input type="checkbox" [checked]="selectedKits.includes(kit)" />
      <label>{{ kit.name }}</label>
    </div>
  </div>

  <!-- Footer -->
  <div class="footer">
    <button class="reset-btn" (click)="resetKits()">Reset</button>
    <button class="ok-btn" (click)="ok()">OK ({{ selectedKits.length }})</button>
  </div>
</div>


      <div class="chip-container" >
      <mat-chip-list>
        <mat-chip *ngFor="let kit of selectedKits" [removable]="true" (removed)="removeKit(kit)" class="chip">
          {{ kit.name }}
          <mat-icon matChipRemove class="remove-btn" (click)="removeKit(kit)" style="color: #144579 !important;">cancel</mat-icon>
        </mat-chip>
      </mat-chip-list>
    </div>
  </div>

  <!-- Manual Entry -->
  <div class="card manual-card">
    <div class="header" style="justify-content: flex-start;gap: 6px;">    
      <div class="edit">
    <i> edit</i>
    </div>
    <div class="quick"> 
      <p class="start">Manual Entry</p>
    <p class="sub-text">Type part names naturally</p>
    </div>
    </div>
    <div class="matformfieldnew1">
        <mat-form-field appearance="outline" style="width: 100%;">
        <!-- <mat-form-field  class="custom-mat        -form-field"> -->
          <!-- <div class="custom-textarea-container"> -->
            <mat-label style="font-size: 12px;     text-wrap-mode: wrap;">Example: brake pad, clutch cable,wiper motor...</mat-label>
            <textarea matInput (click)="scrollToTarget()" [(ngModel)]="itemList" rows="15" style="text-align: left;" class="textarea"></textarea>
          <!-- </div> -->
           <!-- <button class="mic-button" (click)="startVoiceRecognition()">
            <i class="material-icons">mic</i>
          </button> -->
        </mat-form-field>   
    </div> 
    <!-- <div class="textarea-wrapper">
      <textarea matInput
        placeholder="Example: brake pad, clutch cable, wiper motor, ac condenser..."
        [(ngModel)]="userText"
        rows="4"
      ></textarea>
      <button class="mic-button" (click)="startVoiceToText()">
        <i class="material-icons">mic</i>
      </button>
    </div> -->

    <!-- <textarea placeholder="Example: brake pad, clutch cable, wiper motor, ac condenser..."></textarea>
    <button class="voice-btn">🎤</button> -->
  </div>

  <!-- Pro Tips -->
  <div class="card tips-card">
    <div class="header"  style="justify-content: flex-start;gap: 6px;"> 
      <div class="star">
    <i> star</i>
    </div>
        <div class="quick"> 
        <p class="start"> Pro Tips</p>
        <p>Smart suggestions for better results</p>
      </div>
      </div>
    <div class="pro-tip-card">
  <div class="pro-tip-header">
    💡 <span>Spelling mistakes will be <strong>auto-corrected</strong></span>
  </div>

  <div class="pro-tip-list">
    <ul>
      <li><span>✓</span> Multi-part paste</li>
      <li><span>✓</span>  Voice input</li>
    </ul>
    <ul>
      <li><span>✓</span>  Auto-correction</li>
      <li><span>✓</span>  Smart matching</li>
    </ul>
  </div>
</div>

  </div>
  <div class="error-msg" *ngIf="showError1">
    Please enter at least one item name to proceed.
  </div>
  <!-- Action Button -->
  <button class="quote-btn" (click)="reviewParts(true)"><img src="../../../../assets/images/home-page-reg-number/Vector.png"> Create Request</button>
  <!-- <div class="footer-help"><i>info</i>Need help? Talk to our parts expert</div> -->
</div>
</div>

</div>
<div class="overlay1" [class.visible]="openReview" (click)="reviewParts(false)"></div>
<div class="sidebar1" [class.visible]="openReview" *ngIf="openReview" style="padding: 0;background: linear-gradient(87deg, #F0F9FF, #E0F2FE, #F0FDFA);">
<div class="review-container">
  <mat-icon (click)="reviewParts(false)" class="arrow">arrow_back</mat-icon>
  <div class="header">
    <div class="icon-box">
      <img src="../../../../assets/images/home-page-reg-number/car.png">
    </div>
    <h2>Review your parts 🧾</h2>
    <p>We've corrected any spelling errors and<br>added 1 quantity by default.</p>
  </div> 

  <div class="part-card" *ngFor="let part of itemSet">
    <div [ngClass]="{'part-header': isDifferentName(part.name, getSuggestionName(part.name))}">
      <small *ngIf="isDifferentName(part.name, getSuggestionName(part.name))"> {{ part.name | titlecase }}</small>
      <span
        class="status-badge auto-corrected"
         *ngIf="isDifferentName(part.name, getSuggestionName(part.name))"
      >
        ✅ Auto-corrected
      </span>
      <span
        class="status-badge as-typed"
        *ngIf="!isDifferentName(part.name, getSuggestionName(part.name))"
        >
        ⚠️ As typed
      </span>
    </div>

    <div class="part-name">
      <span *ngIf="isDifferentName(part.name, getSuggestionName(part.name))">➜</span>
      {{ getSuggestionName(part.name) | titlecase}}
       <img src="../../../../assets/images/home-page-reg-number/edit.png" style="margin-top: 3px;padding: 0;cursor: pointer;" (click)="openModal(part)">
    </div>

    <div class="quantity-control">
      <span>Qty</span>
      <button (click)="decreaseQty(part)">−</button>
      <span style="font-weight: 600;">{{ getItemQuantity(part.name) || 1 }}</span>
      <button (click)="increaseQty(part)">+</button>
      <button class="delete-btn" (click)="deletePart(part)"><img src="../../../../assets/images/home-page-reg-number/delete.png"></button>
    </div>
  </div>

  <!-- <div class="help-section">
    <img src="../../../../assets/images/home-page-reg-number/msg.png">Need help? Talk to expert
  </div> -->

<!-- Modal -->
<div class="modal" *ngIf="showModal">
  <div class="modal-content">
    <div class="modal-header">
      <h2>Edit Item</h2>
      <button class="close" (click)="closeModal()">×</button>
    </div>

<!-- <div class="you-typed">
  <div class="typed">
    <i>perm_identity</i>
    <p>You typed <strong style="color: #3F5B73;font-size: 13px;">{{asTypedPart.name}}</strong></p>
  </div>
  <div class="use">
    <p (click)="asTyped()">Use as typed</p>
  </div>
</div> -->
    <div class="input-group">
      <input
        type="text"
        [(ngModel)]="searchTextName"
        (input)="filterSuggestions()"
        placeholder="Search & select correct item..."
      />
      <button *ngIf="searchTextName.length > 0" (click)="cancelName()">×</button>
    </div>

    <div class="suggestions-value" *ngIf="searchTextShow" >
      <p>Suggestions</p>
      <div *ngFor="let suggestion of suggestions">
        <div (click)="selectSuggestion(suggestion)"  class="suggestion">
        <i class="material-icons">search</i>
        <div [innerHTML]="getHighlightedText(suggestion.value, searchTextName)"></div>
        </div>
        </div>
    </div>

    <button class="save-btn" (click)="saveItem()">Save Item</button>

    <div class="tag" *ngIf="selectedValue">
      Saved: {{ selectedValue }} ({{ selectedMode === 'typed' ? 'As typed' : 'Auto Corrected' }})
    </div>
  </div>
</div>
<div class="photo-sec">
<div class="add-image-card" *ngIf="imagePreviews.length<= 0">


  <div class="header">
    <span class="material-icons camera-icon">photo_camera</span>
    <span class="title">Add images (optional)</span>
  </div>

  <p class="subtitle">
    Not sure about the part? A photo helps our team quote faster.
  </p>

  <input
    type="file"
    id="imageUpload"
    hidden
    multiple
    accept="image/*"
    (change)="onFileSelected($event)"
  />

  <label class="upload-box" for="imageUpload">

    <div class="camera-circle">
      <span class="material-icons">photo_camera</span>
    </div>

    <div class="upload-title">Upload part photos</div>
    <div class="upload-subtitle">You can add multiple images</div>

  </label>


</div>
<div class="photo-card" *ngIf="imagePreviews.length >0">

 
  <div class="header">
    <span class="material-icons camera-icon">photo_camera</span>
    <div>
      <div class="title">
       Add images (optional)
      </div>
      <div class="subtitle">
       Not sure about the part? A photo helps our team quote faster.
      </div>
    </div>
  </div>
  <div class="image-added">
  <p>Added photos ({{imagePreviews.length}})</p>
  <label for="imageUpload" class="add-more-img">
    <span >+ Add more images</span>
  </label>
</div>

  <input
    type="file"
    id="imageUpload"
    hidden
    multiple
    accept="image/*"
    (change)="onFileSelected($event)"
  />

  <div class="image-row">

    <div
      class="image-box"
      *ngFor="let img of imagePreviews; let i = index"
    >
      <img [src]="img" (click)="openImagePreview(img)" />

      <span
        class="material-icons remove-icon"
        (click)="removeImage(i)"
      >
        close
      </span>
    </div>

    <label for="imageUpload" class="image-box add-box">
      <span class="material-icons">add</span>
    </label>

  </div>

  <div class="info-box">
    <span class="material-icons info-icon">info</span>
    <span>
      This helps our team suggest the correct parts and speeds up your quote.
    </span>
  </div>

</div>
 <!-- IMAGE POPUP -->
        <div
          class="overlay-img-preview"
          [class.visible]="imagePreviewOpen"
          (click)="closeImagePreview()"
        ></div>
        <div class="image-preview-modal" [class.open]="imagePreviewOpen">
          <span class="material-icons close-btn-preview-modal" (click)="closeImagePreview()">close</span>
          <img [src]="previewImageUrl" />
        </div>
</div>


  <button class="magic-btn" (click)="goToMagicQuote(true, false, false)"><img src="../../../../assets/images/home-page-reg-number/Vector.png">✨ Create Request</button>
</div>
</div>

  <div class="popup-overlay" *ngIf="popupContainer">
    <div class="popup-container">
  <div class="popup-main">
    <div class="icon-circle right">
      <img src="../../../../assets/images/home-page-reg-number/right.png">
    </div>
    <h3 class="title">AUTOVERSE</h3>
    <div class="icon-circle info">
      <img src="../../../../assets/images/home-page-reg-number/info.png">
    </div>
    <h3 class="title">Oops! We couldn't quote your parts right now</h3>
    <p class="subtitle">But don't worry! We've created a request for you. <br />Our parts expert is working on it. ✅</p>

    <div class="request-box">
      <strong><i>check_circle</i>Request ID:{{response?.data.requestId}}</strong>
      <span>You can track it anytime in the 'My Requests' page.</span>
    </div>

    <button class="btn req" (click)="requestSuccessPopup()"><i>notes</i>Go to My Requests</button>
    <button class="btn outline" (click)="tryAgain()"><i>replay</i>Try Again</button>

    <div class="info-section">
        <i>error</i>
        <div>
      <h4>What happens next?</h4>
      <p>Your request will reach our network of suppliers across locations. You'll receive a quote within 30 minutes.</p>
      </div>
    </div>

  </div>
  
    <div class="why-section">
      <h4><i>done</i>Why couldn't we quote immediately?</h4>
      <ul>
        <li>Parts not available in our nearest warehouse</li>
        <li>Rare or specialised components requiring supplier search</li>
        <li>Custom pricing needed for bulk orders</li>
      </ul>
    </div>

    <!-- <div class="footer">
      <p>
        Need immediate assistance? Contact our support team at
        <strong>support@autoverse.in</strong> or
        <strong>+91 8050464442</strong>
      </p>
    </div> -->
  </div>
</div>

<div class="popup" *ngIf="isPopupOpen">
    <div class="popup-content order-success-sec">
      <!-- <button mat-button (click)="closePopup()">Close</button> -->
      <img src="{{ successIcon }}" alt="Success Icon">
      <!-- <button class="close-popup" (click)="closePopup()">×</button> -->
      <mat-icon class="close-popup" (click)="closePopup()">close</mat-icon>
      <h3 *ngIf="addMoreItemsId">Request Updated!</h3>
      <h3 *ngIf="!addMoreItemsId">Request Created!</h3>
      <!-- <p class="order-label"><span class="order-id">Request ID  {{response.data.requestId}}</span></p> -->
      <p class="order-label">
        <span class="order-id">
          Request ID 
          {{ updatePopupData?.requestId || response?.data?.requestId }}
        </span>
      </p>
      <p class="date">
        <span>
          {{ updatePopupData?.requestCreatedAt || response?.data?.requestCreatedAt | date:'dd MMM yyyy, hh:mm a':'GMT+1060' }}
        </span>
      </p>
      <p class="date"  *ngIf="updatePopupData"><span>{{ response.data.requestCreatedAt | date:'dd MMM yyyy, hh:mm a':'GMT+1060' }}</span></p>
      <p class="thank-you">Let us deliver an awesome experience!</p>
      <!-- <button class="goto-order" (click)="closePopup()">Track My Request </button> -->
      <button class="goto-order" (click)="goToRequestDetails(spareRequestId)">
        Track My Request
      </button>
    </div>
  </div>
<div #magicQuote></div>


<!-- Existing content above -->

<!-- Request Exists Popup -->
<div class="overlay12" [class.visible]="isRequestExistsPopupOpen" (click)="closeDetails(false)"></div>
<div class="overlay12" [class.visible]="isRequestExistsPopupOpen" (click)="closeRequestExistsPopup()"></div>

<div class="req-exists-overlay" *ngIf="isRequestExistsPopupOpen">
  <div class="req-exists-container">
    <!-- Close icon -->
    <!-- <mat-icon class="req-close-icon" (click)="closeRequestExistsPopup()">close</mat-icon> -->
     <div class="div-with-close">
      <!-- Header -->
      <div class="req-header">
        <div class="req-second-header">

          <h3>Request already exists for {{ regNo }}</h3>
          <div class="req-tags">
            <div class="req-id"> 
              <div style="display: flex;align-items: center;"><svg style =" width: 15px; height: 15px;opacity: 1;" width="17" height="21" viewBox="0 0 17 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M5.47461 3.59735H3.47461C2.94418 3.59735 2.43547 3.80806 2.0604 4.18314C1.68532 4.55821 1.47461 5.06692 1.47461 5.59735V17.5974C1.47461 18.1278 1.68532 18.6365 2.0604 19.0116C2.43547 19.3866 2.94418 19.5974 3.47461 19.5974H13.4746C14.005 19.5974 14.5137 19.3866 14.8888 19.0116C15.2639 18.6365 15.4746 18.1278 15.4746 17.5974V5.59735C15.4746 5.06692 15.2639 4.55821 14.8888 4.18314C14.5137 3.80806 14.005 3.59735 13.4746 3.59735H11.4746M5.47461 3.59735C5.47461 4.12778 5.68532 4.63649 6.0604 5.01156C6.43547 5.38664 6.94418 5.59735 7.47461 5.59735H9.47461C10.005 5.59735 10.5137 5.38664 10.8888 5.01156C11.2639 4.63649 11.4746 4.12778 11.4746 3.59735M5.47461 3.59735C5.47461 3.06692 5.68532 2.55821 6.0604 2.18314C6.43547 1.80806 6.94418 1.59735 7.47461 1.59735H9.47461C10.005 1.59735 10.5137 1.80806 10.8888 2.18314C11.2639 2.55821 11.4746 3.06692 11.4746 3.59735M8.47461 10.5974H11.4746M8.47461 14.5974H11.4746M5.47461 10.5974H5.48461M5.47461 14.5974H5.48461" stroke="#1B5CA0" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg></div>
              <div>Request #{{ existingRequest?.requestId }}</div>
            </div>
             <div class="req-status" [ngClass]="{
                    'requested': getOverallStatus(existingRequest.response.body.spareRequestItemList) === '⏳ Requested',
                    'quote-received': getOverallStatus(existingRequest.response.body.spareRequestItemList) === '💬 Quote Received',
                    'quote-approved': getOverallStatus(existingRequest.response.body.spareRequestItemList) === '✅ Quote Approved',
                    'order-created': getOverallStatus(existingRequest.response.body.spareRequestItemList) === '📦 Order Created'
                  }">
                {{ getOverallStatus(existingRequest.response.body.spareRequestItemList) }}
              </div>
              <div class="req-footer">
                <mat-icon class="req-close-icon" (click)="closeRequestExistsPopup()">close</mat-icon>
              </div>
          </div>
        </div>
          <!-- Car info -->
            <p class="req-car-info">Car: 
              {{ vehicleData?.make }} {{ vehicleData?.model }} • {{ vehicleData?.year }} • {{vehicleData.variant}} {{ vehicleData?.fuel }}
            </p>
            <!-- <p><span class="icon">🚗</span> {{vehicleData.make}} {{vehicleData.model}} | {{vehicleData.variant}}</p>
              <p><span class="icon">⛽</span>{{vehicleData.fuel}}  | {{vehicleData.year}}  | {{carNumber}} </p> -->

            <p class="req-description">
              You can either start a fresh request or add your current parts to the existing one. Choose what suits you.
            </p>
      </div>
    </div>


    <!-- Two-column layout -->
     <h4>Existing request summary</h4>
    <div class="req-content">
      <!-- Left: Existing request summary -->
      <div class="req-summary">
        <div class="req-summary-header">
          <!-- <span class="req-created">Created: {{ existingRequest?.createdAt || 'Today, 10:42 AM' }}</span> -->
          <span class="req-created">
            Created: {{ getCreatedDate(existingRequest?.response?.body?.spareRequest?.created) }}
          </span>
        </div>

        <div class="req-items" [ngClass]="{ 'scrollable': showFullItems }">
          <div class="req-item" *ngFor="let item of getVisibleItems(existingRequestItems)">
            <span class="name">{{ item.itemName }}</span>
            <span class="qty">Qty: {{ item.itemQuantity }}</span>
          </div>
        </div>

        <button *ngIf="existingRequestItems.length > 3"
                class="view-full"
                (click)="toggleFullItems()">
          {{ showFullItems ? 'Show less' : 'View full request' }}
        </button>

      </div>

      <!-- Right: Actions -->
      <div class="req-actions">
        <h4>What would you like to do?</h4>
        <button class="btn fresh" (click)="goToMagicQuote(false, false, true)">Start a Fresh Request</button>
        <button class="btn add" (click)="updateExistingRequest()">Add Items to Existing</button>
        <p class="tip">
          <strong>Tip:</strong> Fresh request keeps this one separate.<br />
          Add-to-Existing will merge the parts you’re reviewing now into the above request.
        </p>
      </div>
    </div>
  </div>
</div>

